module.exports = __webpack_public_path__ + "static/media/2.085d3a3c.png";